import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Link } from "gatsby";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { SiHomify } from "react-icons/si";
import { SiHouzz } from "react-icons/si";
import { FaYoutube } from "react-icons/fa";
import {
  Ville,
  Rville,
  Rregion,
  variablesSubstitution,
} from "../components/Variables-en";
import ReadMoreWhite from "../components/ReadMoreWhite";

const FooterComponentEn = ({ ...props }) => (
  <Footer>
    <Row>
      <Col1>
        <Title>
          <StyledLink to="/en/stores/">
            Shops we recommand <Rville />
          </StyledLink>
        </Title>
        <P>
          Check out the stores we recommand <Rville /> and <Rregion />. These
          stores specialized in furniture and decoration allow you to arrange
          your interior in the style that suits you the most: design,
          contemporary, industrial, nature, scandinavian, vintage or classic. By
          working with our decorators and architects for your interior design
          project, you may benefit from preferential discounts from these
          stores.
        </P>

        <ReadMoreWhite
          link="/en/stores/"
          title={variablesSubstitution("Stores that we like in vville")}
        />
      </Col1>
      <Col2>
        <Title>Find us in…</Title>
        <Ul
          css={css`
            columns: 2;
            -webkit-columns: 2;
            -moz-columns: 2;
          `}
        >
          <Li>
            <A
              href="https://www.architectes-interieur-aix-en-provence.com/"
              title="Interior designer in Aix-en-Provence"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aix-en-Provence
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-annecy.com/"
              title="Architecte d'intérieur à Annecy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Annecy
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-biarritz.com/en/"
              title="Interior designer in Biarritz"
              target="_blank"
              rel="noopener noreferrer"
            >
              Biarritz
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-bordeaux.com"
              title="Interior designer in Bordeaux"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bordeaux
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-bruxelles.com/en/"
              title="Interior designer and interior architect in Bruxelles"
              target="_blank"
              rel="noopener noreferrer"
            >
              Brussels
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-lille.fr/en/"
              title="Interior designer and interior architect in Lille"
              target="_blank"
              rel="noopener noreferrer"
            >
              Lille
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-lyon.com/en/"
              title="Interior architect in Lyon"
              target="_blank"
              rel="noopener noreferrer"
            >
              Lyon
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-marseille.com/en/"
              title="Interior designer and interior architect in Marseille"
              target="_blank"
              rel="noopener noreferrer"
            >
              Marseille
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-montpellier.com/en/"
              title="Interior designer in Montpellier"
              target="_blank"
              rel="noopener noreferrer"
            >
              Montpellier
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-nantes.com/"
              title="Interior designer and interior architect in Nantes"
              target="_blank"
              rel="noopener noreferrer"
            >
              Nantes
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-nimes.com/"
              title="Interior designer and interior architect in Nîmes"
              target="_blank"
              rel="noopener noreferrer"
            >
              Nîmes
            </A>
          </Li>
          <Li>
            <A
              href="https://www.createursdinterieurs.com"
              title="Interior designer and interior architect in Paris"
              target="_blank"
              rel="noopener noreferrer"
            >
              Paris
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-bretagne.com/en/"
              title="Interior designer and interior architect in Quimper and Bretagne"
              target="_blank"
              rel="noopener noreferrer"
            >
              Quimper
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-var.com/en/"
              title="Interior designer and interior architect in Toulon and Var 83"
              target="_blank"
              rel="noopener noreferrer"
            >
              Toulon
            </A>
          </Li>
          <Li>
            <A
              href="https://www.toulouse-architecte-interieur.com/en/"
              title="Interior designer and interior architect in Toulouse"
              target="_blank"
              rel="noopener noreferrer"
            >
              Toulouse
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-tours.com/en/"
              title="Interior designers and architects in Tours and Touraine"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tours
            </A>
          </Li>
        </Ul>
      </Col2>
      <Col3>
        <Title>More…</Title>
        <Ul>
          <Li>
            <StyledLink to="/presse/">Press</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/en/videos/">Videos</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/en/reviews/">Reviews</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/en/prices/">Prices</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/en/faq/">FAQ</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/en/contact-us/">Contact us</StyledLink>
          </Li>
        </Ul>
      </Col3>
    </Row>
    <Copyright>
      <CopyrightCol1>
        Créateurs d'intérieur <Ville /> © 2025 |{" "}
        <StyledLink to="/mentions-legales/">Terms of service</StyledLink> |{" "}
        <StyledLink to="/cgu/">Conditions of use</StyledLink> |{" "}
        <Link to={props.pathFr}>
          <span role="img" aria-label="Version française">
            🇫🇷&nbsp;
          </span>
          Version française
        </Link>
      </CopyrightCol1>
      <CopyrightCol2>
        <Title
          css={css`
            margin-top: 8px;
            margin-bottom: 10px;
          `}
        >
          Find us on social media:
        </Title>
        <WrapperLogo>
          <LogoItem>
            <A
              href="https://www.facebook.com/createursdinterieurparis"
              title="Créateurs d'intérieur's Facebook account"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookSquare />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.instagram.com/createursdinterieur/"
              title="Créateurs d'intérieur's Instagram account"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.youtube.com/@createursdinterieur"
              title="Créateurs d'intérieur's Youtube channel"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.houzz.fr/pro/createursdinterieur/createurs-d-interieur"
              title="Créateurs d'intérieur's profile on Houzz"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiHouzz />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.homify.fr/experts/7801/createurs-d-interieur"
              title="Homify account of Créateurs d'intérieur"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiHomify />
            </A>
          </LogoItem>
        </WrapperLogo>
      </CopyrightCol2>
    </Copyright>
  </Footer>
);

const Footer = styled.footer`
  background-color: #7a9282;
  padding: 1em 0;
  position: relative;
  z-index: 10;
  a {
    color: white;
    opacity: 0.95;
    text-decoration: none;
  }

  max-width: 100%;
`;

const Row = styled.div`
  width: 1250px;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  @media only screen and (max-width: 1250px) {
    padding: 0 15px;
  }
  @media only screen and (max-width: 900px) {
    display: block;
  }
`;

const Col1 = styled.div`
  flex: 38%;

  padding-right: 30px;
  @media only screen and (max-width: 678px) {
    padding-right: 0;
  }
`;

const Col2 = styled.div`
  flex: 26%;
  padding-left: 25px;
  @media only screen and (max-width: 900px) {
    padding: 0;
  }
`;

const Col3 = styled.div`
  flex: 35%;
  padding-left: 12px;
  @media only screen and (max-width: 900px) {
    padding: 0;
  }
`;

const Title = styled.div`
  color: white;
  font-size: 23px;
  font-weight: 700;
  letter-spacing: 0.075em;
  margin: 0.7em 0 1em;
  @media only screen and (max-width: 768px) {
    font-size: 21px;
  }
`;

const P = styled.p`
  color: white;
  font-size: 0.9em;
  line-height: 1.65em;
  padding-right: 10px;
  margin-bottom: 4px;
`;

const Ul = styled.ul`
  padding-left: 2px;
  margin-bottom: 0;
  @media only screen and (max-width: 768px) {
    list-style-type: none;
    padding-left: 2px;
  }
`;

const Li = styled.li`
  color: white;
  margin-bottom: 3px;
  font-size: 0.88em;
  letter-spacing: 0.03em;
  font-weight: 500;
  list-style-type: none;
`;

const A = styled.a`
  color: white !important;
  text-decoration: none;
  border-bottom: none;
  transition: all 0.1s;
  padding: 0 0 3px 0;
  margin: 0;
  &:hover {
    opacity: 0.75;
    transition: all 0.1s;
  }
`;

const StyledLink = styled(Link)`
  color: white !important;
  text-decoration: none;
  border-bottom: none;
  transition: all 0.1s;
  padding: 3px 0 3px 0;
  margin: 0;
  &:hover {
    opacity: 0.65;
    transition: all 0.1s;
  }
`;

const WrapperLogo = styled.div`
  display: flex;
  padding-right: 110px;
`;

const LogoItem = styled.div`
  flex: 25%;
  font-size: 2.25em;
  padding-top: 3px;
  @media only screen and (max-width: 768px) {
    font-size: 1.75em;
    text-align: center;
  }
`;

const Copyright = styled.div`
  display: flex;
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
  color: white;
  opacity: 0.9;
  font-size: 0.8em;
  font-weight: 600;
  letter-spacing: 0.03em;
  padding-bottom: 10px;
  @media only screen and (max-width: 1250px) {
    padding: 0 15px;
  }
  @media only screen and (max-width: 900px) {
    margin-top: 1.5em;
    line-height: 1.5em;
    flex-direction: column;
  }
`;

const CopyrightCol1 = styled.div`
  flex: 65%;
  align-self: flex-end;
  padding-bottom: 12px;
  @media only screen and (max-width: 900px) {
    margin-top: 15px;
    flex: 100%;
    order: 2;
  }
`;

const CopyrightCol2 = styled.div`
  flex: 35%;
  @media only screen and (max-width: 900px) {
    flex: 100%;
    order: 1;
  }
`;

export default FooterComponentEn;
